import React, { useState } from "react";

import { MultiSelect } from "../MultiSelect";
import { useProcurementMethods } from "newui/store";
import { ProcurementModelGuidanceModal } from "./ProcurementModelGuidanceModal";

const guideLineText = "click to view guidelines for each Procurement Method";

export const ProcurementMethodSelector = ({
	name,
	setFieldValue,
	values,
	defaultValue,
	testId,
	guideLine,
	...props
}) => {
	const { values: methods, isLoading } = useProcurementMethods();
	const [isGuidanceOpen, setIsGuidanceOpen] = useState(false);

	//use this var to create proper label/value obj
	let valueObj = [];

	//pick out the initial values from the options array based on method id's from form
	if (Array.isArray(values[name] && !isLoading)) {
		valueObj = values[name].map((id) => {
			return methods?.find((option) => {
				return option.value === id;
			});
		});
	}

	return (
		<>
			<MultiSelect
				aria-labelledby="multi-select-label"
				aria-describedby="multi-select-description"
				closeMenuOnSelect={false}
				label="Procurement Model"
				options={!isLoading && methods}
				testId={testId}
				name={name}
				value={valueObj}
				guideLine={guideLineText}
				guideLineText={guideLineText}
				isGuideLineLink
				onGuideLineClick={() => setIsGuidanceOpen(true)}
				className={props.className}
				isLoading={isLoading}
			/>
			<ProcurementModelGuidanceModal
				isOpen={isGuidanceOpen}
				onClose={() => setIsGuidanceOpen(false)}
			/>
		</>
	);
};
